import { UiSchema, WidgetProps } from '@rjsf/utils';
import { KnownUploadImageDtoCategory } from '@groundfloor-platform/mgmt-service-g-sdk';
import { CustomObjectFieldTemplate, UIGridElement } from '../shared/custom-object-field-template';
import { DynamicFormImageUpload } from '../shared/dynamic-form-image-upload';
import { DynamicFormToggleGroup } from '../shared/dynamic-form-toggle-group';
import {
  CARRIER_REVIEW_NEEDS_REVIEW,
  NEEDS_REVIEW_LABEL,
  NEEDS_REVIEW_TOOLTIP
} from '../../../carriers/logic/carrier-review';
import { CarrierGroupVariant } from './form';

const organisationGrid: UIGridElement[] = [
  { fields: { name: 12 } },
  { fields: { parent: 8, status: 4 } },
  { title: 'Registration methods', fields: { kioskRegistrationPolicy: 6, qrRegistrationPolicy: 6 } },
  { fields: { registrationTarget: 6 } },
  { title: 'Login method', fields: { loginMethod: 12 } }
];

const unitGrid: UIGridElement[] = [
  { fields: { name: 12 } },
  {
    notice: {
      isEnabledPredicate: (formData) => formData.review === CARRIER_REVIEW_NEEDS_REVIEW,
      title: NEEDS_REVIEW_LABEL,
      notice: NEEDS_REVIEW_TOOLTIP,
      severity: 'warning'
    },
    fields: { parent: 6, status: 3, review: 3 }
  },
  { fields: { image: 12 } },
  { title: 'Registration methods', fields: { kioskRegistrationPolicy: 6, qrRegistrationPolicy: 6 } },
  { title: 'Login method', fields: { loginMethod: 12 } }
];

export function makeCarrierGroupFormUISchema(variant: CarrierGroupVariant): UiSchema {
  return {
    'ui:submitButtonOptions': { norender: true },
    'ui:field': 'custom',
    'ui:grid': variant === 'organisation' ? organisationGrid : unitGrid,
    'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
    image: {
      // Public group image, as the carrier detail page uploads it.
      'ui:options': {
        isPublic: true,
        category: KnownUploadImageDtoCategory.Group,
        showPreview: true,
        buttonLabel: 'Upload logo'
      },
      'ui:widget': (props: WidgetProps) => <DynamicFormImageUpload {...props} />
    },
    loginMethod: {
      'ui:widget': (props: WidgetProps) => <DynamicFormToggleGroup {...props} />
    }
  };
}
